module.exports = __webpack_public_path__ + "img/pending.d62201bf.svg";